import { createBrowserRouter, RouteObject } from 'react-router-dom'

import { routeUrls } from '../constants'
import LoginLayout from 'src/Layout/LoginLayout'
import HomeLayout from 'src/Layout/HomeLayout'
import Login from 'src/Page/Public/Login'
import Users from 'src/Page/Private/Users'
import Trainers from 'src/Page/Private/Trainers'
import WalletRequests from 'src/Page/Private/WalletRequests'
import SaleReports from 'src/Page/Private/SaleReports'
import ManageParks from 'src/Page/Private/ManageParks'
import Messages from 'src/Page/Private/Messages'
import Posts from 'src/Page/Private/Posts'
import AITrainer from 'src/Page/Private/AITrainer'
import Notifications from 'src/Page/Private/Notifications'
import SubscriptionReports from 'src/Page/Private/SubscriptionReports'
import Products from 'src/Page/Private/Products'
import ManageGyms from 'src/Page/Private/ManageGyms'


const routes: RouteObject[] = [
  {
    path: '/',
    element: <LoginLayout />,
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: routeUrls.login,
        element: <Login />,
      },
    ],
  },
  {
    path: routeUrls.home,
    element: <HomeLayout />,
    children: [
      {
        index: true,
        element: <Users />,
      },

      {
        path: routeUrls.trainers,
        element: <Trainers />,
      },
      {
        path: routeUrls.walletRequests,
        element: <WalletRequests />,
      },
      {
        path: routeUrls.products,
        element: <Products />,
      },
      {
        path: routeUrls.saleReports,
        element: <SaleReports />,
      },
      {
        path: routeUrls.subscriptionReports,
        element: <SubscriptionReports />,
      },
      {
        path: routeUrls.manageParks,
        element: <ManageParks />,
      },
      {
        path: routeUrls.manageGyms,
        element: <ManageGyms />,
      },
    
      {
        path: routeUrls.messages,
        element: <Messages />,
      },
      {
        path: routeUrls.posts,
        element: <Posts />,
      },
      {
        path: routeUrls.aiTrainer,
        element: <AITrainer />,
      },
      {
        path: routeUrls.notifications,
        element: <Notifications />,
      },
    ],
  },
]

const router = createBrowserRouter(routes)

export default router
